import { useRef, useState } from "react";
import { Camera, Loader2, Plus, X } from "lucide-react";
import { toast } from "sonner";
import { SecureImg, Lightbox, uploadPhoto } from "@/components/Photos";
import { errMsg } from "@/lib/api";

export function CapSlot({ label, ids, onChange, testid, single = false, required = false, accept = "image/*" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...(e.target.files || [])];
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      const up = [];
      for (const f of files) up.push(await uploadPhoto(f, "private"));
      onChange(single ? up.slice(0, 1) : [...ids, ...up]);
    } catch (er) {
      toast.error(errMsg(er));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid={testid}>
      <div className="text-xs font-semibold text-slate-600 mb-1">{label}{required && <span className="text-rose-600"> *</span>}</div>
      <input ref={ref} type="file" accept={accept} capture={accept === "image/*" ? "environment" : undefined} multiple={!single} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <div className="flex flex-wrap gap-2">
        {ids.map((id) => (
          <div key={id} className="relative">
            <SecureImg id={id} className="w-20 h-20 object-cover rounded-lg border" testid={`${testid}-thumb`} />
            <button type="button" onClick={() => onChange(ids.filter((x) => x !== id))} className="absolute -top-1.5 -right-1.5 bg-white rounded-full border p-0.5" data-testid={`${testid}-remove`}><X className="w-3 h-3" /></button>
          </div>
        ))}
        {(!single || !ids.length) && (
          <button type="button" onClick={() => ref.current.click()} className={`w-20 h-20 rounded-lg border-2 border-dashed flex flex-col items-center justify-center text-[11px] font-semibold transition-colors ${required && !ids.length ? "border-[#F49619] text-[#E0830B]" : "border-slate-300 text-slate-500"} hover:border-[#0E2D43]`} data-testid={`${testid}-add`}>
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : ids.length ? <Plus className="w-5 h-5" /> : <Camera className="w-5 h-5" />}
            {busy ? "Envoi…" : ids.length ? "Ajouter" : "Photo"}
          </button>
        )}
      </div>
    </div>
  );
}

export function Thumbs({ ids, testid }) {
  const [open, setOpen] = useState(null);
  if (!ids?.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {ids.map((id) => <SecureImg key={id} id={id} onClick={() => setOpen(id)} className="w-20 h-20 object-cover rounded-lg border cursor-pointer" />)}
      <Lightbox id={open} onClose={() => setOpen(null)} />
    </div>
  );
}
